export default {
  SET_LISTINGS(state, payload) {
    state.listings = payload;
  },

  SET_PAGES(state, payload) {
    state.pages = payload;
  },

  SET_CATEGORYWISEPAGE(state, payload) {
    state.categorywisepages = payload;
  },

  SET_CATEGORYWISEPAGEFORBLOG(state, payload) {
    state.categorywisepagesforblog = payload;
  },

  SET_CATEGORYWISEPAGEFOREVENT(state, payload) {
    state.categorywisepagesforevent = payload;
  },

  SET_PAGE(state, payload) {
    state.page = payload;
  },

  SET_PAGE_CATEGORIES(state, payload) {
    state.pageCategories = payload;
  },

  SET_CATEGORIES_TAGS(state, payload) {
    state.filtertags = payload;
  },

  SET_FILTERS(state, payload) {
    state.filters = payload;
  },
  // SET_FILTER_TAGS(state, payload) {
  //   state.filtertags = payload;
  // },
  DELETE_PAGE(state, payload) {
    const index = state.categorywisepages.data.findIndex(
      (page) => page._id === payload._id
    );
    state.categorywisepages.data.splice(index, 1);
  },
  SET_SELECTED_BLOG(state, payload) {
    state.selectedBlog = payload;
  },
  SET_SELECTEDPAGECATEGORY(state, payload) {
    state.selectedpagecategory = payload;
  },
  ADD_PAGE(state, payload) {
    state.categorywisepages.data.unshift(payload);
  },
  SET_CAREERS(state, payload) {
    state.careers = payload;
  },
  SET_SELECTED_CAREER(state, payload) {
    state.selectedCareer = payload;
  },
  EDIT_PAGE(state, payload) {
    const index = state.categorywisepages.data.findIndex(
      (page) => page._id === payload._id
    );
    state.categorywisepages.data.splice(index, 1, payload);
  },
  SELECTED_PDF(state, payload) {
    state.selectedpdf = payload;
  },
};
